import dispatcher from 'js/core/dispatcher';
import { authCode } from 'js/library/utils/API/Authentication/authCode';

export const phoneInputAction = (dispatch, cellPhone) => {
  cellPhone = '+' + cellPhone.replace(/\D+/g, '');

  return dispatcher(dispatch, 'PHONE_INPUT', authCode(cellPhone, null));
};
